import { create } from "zustand";

export const useRoleStore = create((set, get) => ({
  roles: [],
  loading: false,
  error: null,
  selectedRole: null,
  searchQuery: "",
  filters: {},
  pagination: {
    page: 1,
    pageSize: 10,
    total: 0,
    totalPages: 1,
  },
  rolesForDropdown: [],
  columnFilters: { isSystemRole: ['false'] },
  uniqueValues: {},

  // Setters
  setRoles: (roles) => set({ roles }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),
  setSelectedRole: (role) => set({ selectedRole: role }),
  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setFilters: (newFilters) => set((state) => ({ filters: { ...state.filters, ...newFilters } })),
  setPagination: (pagination) => set({
    pagination: {
      ...get().pagination,
      ...pagination
    }
  }),
  setRolesForDropdown: (rolesForDropdown) => set({ rolesForDropdown }),
  setColumnFilters: (columnFilters) => set({ columnFilters }),
  setUniqueValues: (uniqueValues) => set({ uniqueValues }),

  // Helpers
  reset: () => set({
    roles: [],
    rolesForDropdown: [],
    loading: false,
    error: null,
    selectedRole: null,
    searchQuery: "",
    filters: {},
    pagination: {
      page: 1,
      pageSize: 10,
      total: 0,
      totalPages: 1,
    },
    columnFilters: { isSystemRole: ['false'] },
    uniqueValues: {},
  })
}));
